<h5 class="card-header text-center p-2">Add Voucher</h5>
@for (alert of successAlerts; track alert) {
  <div>
    <alert [type]="alert.type" [dismissOnTimeout]="alert.timeout">{{ alert.msg }}</alert>
  </div>
}
@for (alert of failureAlerts; track alert) {
  <div>
    <alert [type]="alert.type" [dismissOnTimeout]="alert.timeout">{{ alert.msg }}</alert>
  </div>
}
<div class="card ">
  <div class="card-body">
    <form name="form" (ngSubmit)="voucherForm.form.valid && onSubmit(voucherForm)" #voucherForm="ngForm" novalidate>
      <div class="row pb-3">
        <div class="col-md-4">
          <label class="mb-2" for="email">Email</label>
          <input type="text" name="email_id" class="form-control" [(ngModel)]="model.email_id" #email_id="ngModel" [class.isinvalid]="voucherForm.submitted && email_id.invalid" required email autocomplete="off">
          @if (voucherForm.submitted && email_id.invalid) {
            <div class="invalid-feedback">
              @if (email_id.errors['required']) {
                <div>Please enter the customer email.</div>
              }
              @if (email_id.errors['email']) {
                <div>Email must be a valid email address</div>
              }
            </div>
          }
        </div>
        <div class="col-md-4">
          <label class="mb-2" for="vouchercode">Voucher Code</label>
          <input type="text" [pattern]="'^[a-zA-Z0-9]+$'" name="voucher_code" class="form-control" [(ngModel)]="model.voucher_code" #voucher_code="ngModel" [class.isinvalid]="voucherForm.submitted && voucher_code.invalid" required autocomplete="off">
          @if (voucherForm.submitted && voucher_code.invalid) {
            <div class="invalid-feedback">
              @if (voucher_code.errors['required']) {
                <div>Please enter the voucher code.</div>
              }
              @if (voucher_code.errors['pattern']) {
                <div>Please enter the valid voucher code.</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-md-4">
          <label class="mb-2" for="amount">Amount</label>
          <input type="text" [pattern]="'^[0-9.]+$'" name="voucher_amount" class="form-control" [(ngModel)]="model.voucher_amount" #voucher_amount="ngModel" [class.isinvalid]="voucherForm.submitted && voucher_amount.invalid" required autocomplete="off">
          @if (voucherForm.submitted && voucher_amount.invalid) {
            <div class="invalid-feedback">
              @if (voucher_amount.errors['required']) {
                <div>Please enter the amount.</div>
              }
              @if (voucher_amount.errors['pattern']) {
                <div>Please enter the valid amount.</div>
              }
            </div>
          }
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-md-4">
          <label class="mb-2" for="currency">Currency</label>
          <select id="currency" name="currency" [(ngModel)]="model.currency" class="form-control">
            @for (c of currencies; track c) {
              <option [ngValue]="c">{{c}}</option>
            }
          </select>
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-md-4">
          <label class="mb-2" for="startdate">Start Date</label>
          <input type="text" name="startdate" class="form-control" [(ngModel)]="model.startdate" #startdate="ngModel" [class.isinvalid]="voucherForm.submitted && startdate.invalid"
            #dp="bsDatepicker"
            bsDatepicker [bsConfig]="startDatepickerConfig" placement="top" required autocomplete="off">
            @if (voucherForm.submitted && startdate.invalid) {
              <div class="invalid-feedback">
                @if (startdate.errors['required']) {
                  <div>Please select the expire date.</div>
                }
              </div>
            }
          </div>
          <div class="col-md-4">
            <label class="mb-2" for="expiredate">Expire Date</label>
            <input type="text" name="expiredate" class="form-control" [(ngModel)]="model.expiredate" #expiredate="ngModel" [class.isinvalid]="voucherForm.submitted && expiredate.invalid"
              #dp="bsDatepicker"
              bsDatepicker [bsConfig]="endDatepickerConfig" placement="top" required autocomplete="off">
              @if (voucherForm.submitted && expiredate.invalid) {
                <div class="invalid-feedback">
                  @if (expiredate.errors['required']) {
                    <div>Please select the expire date.</div>
                  }
                </div>
              }
            </div>
            <div class="col-md-4">
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-4">
              <label class="mb-2" for="reference">Reference</label>
              <input type="text" name="reference" class="form-control" [(ngModel)]="model.reference" #reference="ngModel" [class.isinvalid]="voucherForm.submitted && reference.invalid" required autocomplete="off">
              @if (voucherForm.submitted && reference.invalid) {
                <div class="invalid-feedback">
                  @if (reference.errors['required']) {
                    <div>Please enter the reference.</div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-4">
              <label class="mb-2" for="category">Category</label>
              <select id="category" name="category" [(ngModel)]="model.category" class="form-control">
                @for (c of catagories; track c) {
                  <option [ngValue]="c">{{c}}</option>
                }
              </select>
            </div>
          </div>
          <div class="row pb-3">
            <div class="col-md-4">
              <label class="mb-2" for="promotional">Promotional flag</label>
              <select id="promotional" name="promotional" [(ngModel)]="model.isPromotional" class="form-control">
                <option [ngValue]="true">True</option>
                <option [ngValue]="false">False</option>
              </select>
            </div>
          </div>
          <button class="btn btn-primary" type="submit" [disabled]="isSubmit">
            <span class="spinner-border spinner-border-sm spandisabled" role="status" aria-hidden="true" [class.spanenabled]="isSubmit===true"></span>
            Add Voucher
          </button>
        </form>
      </div>
    </div>
